import { render, staticRenderFns } from "./HeaderList.vue?vue&type=template&id=80aaca8c&"
import script from "./HeaderList.vue?vue&type=script&lang=js&"
export * from "./HeaderList.vue?vue&type=script&lang=js&"
import style0 from "./HeaderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports